module.exports = __webpack_public_path__ + "media/images/gallery/oc_m-0666a18d5ca385af2c876ea8a24dfa21.gif";